import { createBrowserRouter } from "react-router-dom";
import MainRoutes from "./MainRoutes";
import SimpleRoutes from "./SimpleRoute";
import LoginPage from "../pages/Auth";

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  MainRoutes,
  SimpleRoutes,
]);

export default router;
